import {getEndpoint, getHeaders} from "../../helpers/endpoint";
import swal from "sweetalert2";

export const REQUEST_CREATE_NOTIFICATION = 'REQUEST_CREATE_NOTIFICATION';
export const SUCCESS_CREATE_NOTIFICATION = 'SUCCESS_CREATE_NOTIFICATION';
export const FAIL_CREATE_NOTIFICATION = 'FAIL_CREATE_NOTIFICATION';

export const createNotification = (payload,  onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_CREATE_NOTIFICATION, payload });

        delete payload.createdAt;
        delete payload.id;
        delete payload.updatedAt;

        return fetch(getEndpoint('createNotification'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_CREATE_NOTIFICATION,
                        error: data.error,
                    });
                }
                else dispatch(successCreateNotification(data, onSuccess, payload));
            })
            .catch((error, type = FAIL_CREATE_NOTIFICATION) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successCreateNotification(response, onSuccess, payload) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_CREATE_NOTIFICATION,
            response,
            payload,
        });
    };
}

export const REQUEST_GET_ALL_NOTIFICATIONS = 'REQUEST_GET_ALL_NOTIFICATIONS';
export const SUCCESS_GET_ALL_NOTIFICATIONS = 'SUCCESS_GET_ALL_NOTIFICATIONS';
export const FAIL_GET_ALL_NOTIFICATIONS = 'FAIL_GET_ALL_NOTIFICATIONS';

export const getAllNotifications = (onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_GET_ALL_NOTIFICATIONS });

        return fetch(getEndpoint('getAllNotifications'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_GET_ALL_NOTIFICATIONS,
                        error: data.error,
                    });
                }
                else dispatch(successGetAllNotifications(data, onSuccess));
            })
            .catch((error, type = FAIL_GET_ALL_NOTIFICATIONS) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successGetAllNotifications(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_GET_ALL_NOTIFICATIONS,
            response,
        });
    };
}

export const REQUEST_GET_SINGLE_NOTIFICATION = 'REQUEST_GET_SINGLE_NOTIFICATION';
export const SUCCESS_GET_SINGLE_NOTIFICATION = 'SUCCESS_GET_SINGLE_NOTIFICATION';
export const FAIL_GET_SINGLE_NOTIFICATION = 'FAIL_GET_SINGLE_NOTIFICATION';

export const getSingleNotification = (notificationId, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_GET_SINGLE_NOTIFICATION });

        return fetch(getEndpoint('getSingleNotification', notificationId), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_GET_SINGLE_NOTIFICATION,
                        error: data.error,
                    });
                }
                else dispatch(successGetSingleNotification(data, onSuccess));
            })
            .catch((error, type = FAIL_GET_SINGLE_NOTIFICATION) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successGetSingleNotification(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_GET_SINGLE_NOTIFICATION,
            response,
        });
    };
}

export const REQUEST_VALIDATE_NOTIFICATION = 'REQUEST_VALIDATE_NOTIFICATION';
export const SUCCESS_VALIDATE_NOTIFICATION = 'SUCCESS_VALIDATE_NOTIFICATION';
export const FAIL_VALIDATE_NOTIFICATION = 'FAIL_VALIDATE_NOTIFICATION';

export const validateNotification = (notificationId, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_VALIDATE_NOTIFICATION });

        return fetch(getEndpoint('validateNotification', notificationId), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_VALIDATE_NOTIFICATION,
                        error: data.error,
                    });
                }
                else dispatch(successValidateNotification(data, onSuccess));
            })
            .catch((error, type = FAIL_VALIDATE_NOTIFICATION) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successValidateNotification(response, onSuccess) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_VALIDATE_NOTIFICATION,
            response,
        });
    };
}

export const REQUEST_DELETE_NOTIFICATION = 'REQUEST_DELETE_NOTIFICATION';
export const SUCCESS_DELETE_NOTIFICATION = 'SUCCESS_DELETE_NOTIFICATION';
export const FAIL_DELETE_NOTIFICATION = 'FAIL_DELETE_NOTIFICATION';

export const deleteNotification = (notificationId, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_DELETE_NOTIFICATION });

        return fetch(getEndpoint('deleteNotification', notificationId), {
            method: 'DELETE',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_DELETE_NOTIFICATION,
                        error: data.error,
                    });
                }
                else dispatch(successDeleteNotification(data, onSuccess, notificationId));
            })
            .catch((error, type = FAIL_DELETE_NOTIFICATION) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successDeleteNotification(response, onSuccess, notificationId) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_DELETE_NOTIFICATION,
            response,
            notificationId,
        });
    };
}

export const REQUEST_GET_NOTIFICATIONS_CLICKS = 'REQUEST_GET_NOTIFICATIONS_CLICKS';
export const SUCCESS_GET_NOTIFICATIONS_CLICKS = 'SUCCESS_GET_NOTIFICATIONS_CLICKS';
export const FAIL_GET_NOTIFICATIONS_CLICKS = 'FAIL_GET_NOTIFICATIONS_CLICKS';

export const getNotificationsClicks = (payload, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_GET_NOTIFICATIONS_CLICKS });

        return fetch(getEndpoint('getNotificationsClicks'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_GET_NOTIFICATIONS_CLICKS,
                        error: data.error,
                    });
                }
                else dispatch(successGetNotificationsClicks(data, onSuccess, payload));
            })
            .catch((error, type = FAIL_GET_NOTIFICATIONS_CLICKS) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successGetNotificationsClicks(response, onSuccess, payload) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_GET_NOTIFICATIONS_CLICKS,
            response,
            payload,
        });
    };
}

export const REQUEST_CALCULATE_TARGET_IN_APP_NOTIF = 'REQUEST_CALCULATE_TARGET_IN_APP_NOTIF';
export const SUCCESS_CALCULATE_TARGET_IN_APP_NOTIF = 'SUCCESS_CALCULATE_TARGET_IN_APP_NOTIF';
export const FAIL_CALCULATE_TARGET_IN_APP_NOTIF = 'FAIL_CALCULATE_TARGET_IN_APP_NOTIF';

export const calculateTarget = (payload, onSuccess, onError, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest();
        dispatch({ type: REQUEST_CALCULATE_TARGET_IN_APP_NOTIF });

        return fetch(getEndpoint('calculateTarget'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_CALCULATE_TARGET_IN_APP_NOTIF,
                        error: data.error,
                    });
                }
                else dispatch(successCalculateTarget(data, onSuccess, payload));
            })
            .catch((error, type = FAIL_CALCULATE_TARGET_IN_APP_NOTIF) => {
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong with: "${error.error}"<br/>`
                });
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successCalculateTarget(response, onSuccess, payload) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_CALCULATE_TARGET_IN_APP_NOTIF,
            response,
            payload,
        });
    };
}

export const REQUEST_UPDATE_NOTIFICATION = 'REQUEST_UPDATE_NOTIFICATION';
export const SUCCESS_UPDATE_NOTIFICATION = 'SUCCESS_UPDATE_NOTIFICATION';
export const FAIL_UPDATE_NOTIFICATION = 'FAIL_UPDATE_NOTIFICATION';

export const updateNotification = (notificationId, payload, onSuccess, onError) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_UPDATE_NOTIFICATION });
        delete payload.createdAt;
        delete payload.id;
        delete payload.updatedAt;
        return fetch(getEndpoint('updateNotification', notificationId), {
            method: 'PUT',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if(data.error) {
                    if (onError) onError(data.error);
                    dispatch({
                        type: FAIL_UPDATE_NOTIFICATION,
                        error: data.error,
                    });
                }
                else dispatch(successUpdateNotification(data, onSuccess, payload));
            })
            .catch((error, type = FAIL_UPDATE_NOTIFICATION) => {
                if (onError) onError(error);
                dispatch({ type, error });
            });
    };
};

function successUpdateNotification(response, onSuccess, payload) {
    if (onSuccess) onSuccess(response);
    return dispatch => {
        dispatch({
            type: SUCCESS_UPDATE_NOTIFICATION,
            response,
            payload,
        });
    };
}

export const sendInAppNotifUsersTest = (notificationId, payload, onSuccess, onError) => {
    return (dispatch, getState) => {
        return fetch(getEndpoint('sendInAppNotifUsersTest', notificationId), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
                if (data.error) {
                    swal({
                        title: `Oops...`,
                        type: 'error',
                        html: `Something went wrong !<br/>${data.error}<br/>`,
                    });
                    if (onError) onError(data.error);
                }
                else if (onSuccess) {
                    onSuccess(data);
                }
            })
            .catch((error) => {
                swal({
                    title: `Oops...`,
                    type: 'error',
                    html: `Something went wrong !<br/>${error}<br/>`,
                });
                if (onError) onError(error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/notificationsCenter.js